<div class="flex flex-column">
  <div class="flex mb-4 gap-2 w-full">
    <toolbar class="w-full" title="Opérations" [actions]="toolbarActions" />
  </div>

  
  <div class="alm-card p-0 mb-4 border-round-2xl shadow-1 transition-all transition-duration-300 hover:shadow-3 bg-white">
    <div class="bg-white border-round-bottom-xl m-4 border-3 border-gray-100">
      <!-- Formulaire de recherche -->
      <p-card class="mb-4">
        <ng-template pTemplate="header">
          <div class="px-3 pt-3">
            <h3 class="m-0">Recherche d'opérations</h3>
          </div>
        </ng-template>
    
        <form [formGroup]="searchForm" class="flex align-items-end gap-3">
          <!-- Institution -->
          <div class="flex-1">
            <label for="institution" class="block mb-2">Institution</label>
            <p-select
              id="institution"
              formControlName="institutionId"
              [options]="institutions"
              optionLabel="name"
              optionValue="id"
              placeholder="Sélectionner une institution"
              [filter]="true"
              [showClear]="true"
              styleClass="w-full">
            </p-select>
          </div>
    
          <!-- Compte -->
          <div class="flex-1">
            <label for="account" class="block mb-2">Compte</label>
            <p-select
              id="account"
              formControlName="accountId"
              [options]="accounts"
              optionLabel="libelle"
              optionValue="id"
              placeholder="Sélectionner un compte"
              [filter]="true"
              [showClear]="true"
              styleClass="w-full">
            </p-select>
          </div>
    
          <!-- Période (Date d'opération) -->
          <div class="flex-1">
            <label class="block mb-2">Période (Date d'opération)</label>
            <date-range
              [minDate]="minDate"
              [rangeDates]="rangeDates"
              (dateRangeSelected)="onDateRangeSelected($event)"
              (invalidRange)="onInvalidRange($event)" />
          </div>
    
          <!-- Devise -->
          <div class="flex-1">
            <label for="currency" class="block mb-2">Devise</label>
            <p-select
              id="currency"
              formControlName="currencyCode"
              [options]="currencies"
              optionLabel="code"
              optionValue="code"
              placeholder="Sélectionner une devise"
              [filter]="true"
              [showClear]="true"
              styleClass="w-full">
            </p-select>
          </div>
    
          <!-- Sens -->
          <div class="flex-1">
            <label for="sens" class="block mb-2">Sens</label>
            <p-select
              id="sens"
              formControlName="sens"
              [options]="sensOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Sélectionner le sens"
              [showClear]="true"
              styleClass="w-full">
            </p-select>
          </div>
    
          <!-- Boutons d'action -->
          <div class="flex gap-2">
            <p-button
              icon="pi pi-refresh"
              severity="secondary"
              [rounded]="true"
              pTooltip="Réinitialiser"
              tooltipPosition="top"
              (onClick)="onReset()">
            </p-button>
            <p-button
              icon="pi pi-search"
              severity="primary"
              [rounded]="true"
              pTooltip="Rechercher"
              tooltipPosition="top"
              (onClick)="onSearch()">
            </p-button>
          </div>
        </form>
      </p-card>
    </div>
    <div class="bg-white border-round-bottom-xl m-4 border-3 border-gray-100">
      <dynamic-table [headers]="columns" [data]="operations" [pageParams]="pageable"
                    [actions]="actions" (paginate)="onPageChange($event)">
        <div *ngIf="!hasSearched" class="text-center p-5">
          <i class="pi pi-search" style="font-size: 3rem; color: var(--surface-400);"></i>
          <p class="text-xl mt-3" style="color: var(--surface-600);">Veuillez effectuer une recherche pour afficher les opérations</p>
        </div>
        <p-progressSpinner [hidden]="!displaySpinner" strokeWidth="2" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px', stoke: '#004F78' }" />

        <div *ngIf="hasSearched && operations.length === 0 && !displaySpinner" class="text-center p-5">
          <i class="pi pi-inbox" style="font-size: 3rem; color: var(--surface-400);"></i>
          <p class="text-xl mt-3" style="color: var(--surface-600);">Aucune opération trouvée</p>
        </div>
      </dynamic-table>
    </div>
  </div>
</div>
